import Head from 'next/head'

interface MetadataProps {
    metadata?: {
        description?: string
        title?: string
        canonical?: string
    }
}

const MetadataHead = ({ metadata }: MetadataProps) => {
    return (
        <Head>
            {metadata != null ? (
                <meta name="robots" content="index, follow" />
            ) : (
                <meta name="robots" content="noindex, nofollow" />
            )}
            {metadata?.title ? (
                <title>{metadata.title}</title>
            ) : (
                <title>
                    Compare the UK’s Top Credit Cards with TotallyMoney
                </title>
            )}
            {metadata?.description ? (
                <meta name="description" content={metadata.description} />
            ) : null}
            {metadata?.canonical ? (
                <link rel="canonical" href={metadata.canonical} />
            ) : null}
        </Head>
    )
}

export default MetadataHead
